import {ClassifyListStore} from "./classify-list.store";
import React from "react";
import {LoginStore} from "./login.store";
import {ManagerStore} from "./manager.store";
import {UserStore} from "./user.store";
import {BaseLibraryStore} from "./base-library.store";
import {SpecimenStore} from "./specimen.store";
import {PictureStore} from "./picture.store";
import {SearchStore} from "./search.store";
import { AboutUsStore } from "./about.store";
import SearchGlobal from "../views/search/search-global";
import {SearchGlobalStore} from "./search-global.store";
import {HomeLibraryStore} from "./home-library.store";
import {SystemStore} from "./system.store";
import { ScienceStore } from "./science.store";
import {ImageLibraryStore} from "./image-library.store";
import {DnaLibraryStore} from "./dna-library.store";
import {EditPwdStore} from "./edit-pwd.store";

class RootStore {

    public classifyListStore: ClassifyListStore;
    public loginStore: LoginStore;
    public managerStore: ManagerStore;
    public userInfoStore: UserStore;
    public baseLibraryStore: BaseLibraryStore;
    public specimenStore: SpecimenStore;
    public PictureStore: PictureStore;
    public searchStore: SearchStore;
    public searchGlobal: SearchGlobalStore;
    public homeLibrary: HomeLibraryStore;
    public systemStore: SystemStore;
    public scienceStore: ScienceStore;
    public imageLibraryStore: ImageLibraryStore;
    public dnaLibraryStore: DnaLibraryStore;
    public aboutUsStore: AboutUsStore;
    public editPwdStore: EditPwdStore;

    constructor() {
        this.classifyListStore = new ClassifyListStore();
        this.loginStore = new LoginStore();
        this.managerStore = new ManagerStore();
        this.userInfoStore = new UserStore();
        this.baseLibraryStore = new BaseLibraryStore();
        this.specimenStore = new SpecimenStore();
        this.PictureStore = new PictureStore();
        this.searchStore = new SearchStore();
        this.searchGlobal = new SearchGlobalStore();
        this.homeLibrary = new HomeLibraryStore();
        this.systemStore = new SystemStore();
        this.scienceStore = new ScienceStore();
        this.imageLibraryStore = new ImageLibraryStore();
        this.dnaLibraryStore = new DnaLibraryStore();
        this.aboutUsStore = new AboutUsStore();
        this.editPwdStore = new EditPwdStore();
    }
}

const context = React.createContext(new RootStore());
const useStore = () => React.useContext(context);
export { useStore } ;